module.exports = __webpack_public_path__ + "img/full-logo.667759d6.svg";